module.exports = __webpack_public_path__ + "img/source-code-pro-v22-latin-regular.0d74abab.svg";